import { render } from "./PefDetailView.vue?vue&type=template&id=20b9c6b8"
import script from "./PefDetailView.vue?vue&type=script&lang=js"
export * from "./PefDetailView.vue?vue&type=script&lang=js"

import "./PefDetailView.vue?vue&type=style&index=0&id=20b9c6b8&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__